var formatRelativeLocale = {
  lastWeek: '[last] dddd [at] LT',
  yesterday: '[yesterday at] LT',
  today: '[today at] LT',
  tomorrow: '[tomorrow at] LT',
  nextWeek: 'dddd [at] LT',
  other: 'L'
}

export default function formatRelative (token, date, baseDate, options) {
  return formatRelativeLocale[token]
}



//////////////////
// WEBPACK FOOTER
// ../~/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
// module id = 955
// module chunks = 0